import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rules-regulations',
  templateUrl: './rules-regulations.component.html',
  styleUrls: ['./rules-regulations.component.scss']
})
export class RulesRegulationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
